import * as React from "react";
import {isEmpty as _isEmpty} from "lodash";
import {IDoctorCheckInInfo} from "@curefit/care-common";
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader";
import {AppConstants} from "../../../utils/AppConstants";
import AppUtils from "../../../utils/AppUtils";
import {IReferral} from "../../../models/LCPlanClientModels";

export interface AdditionalInstructionsViewProps {
    patientReferrals: IReferral[],
    staticSpecialities: any[]
}

let AdditionalInstructionsHeaderInfos: ICustomHeaderInfo[] = [
    {label: "speciality", display: "SPECIALITY"},
    {label: "type", display: "CONSULTATION TYPE"},
    {label: "reason", display: "REASON"},
    {label: "when", display: "WHEN"}
];

let AdditionalInstructionsSecondaryHeaderInfos: ICustomHeaderInfo[] = [
    {label: "followUp", display: "FOLLOW UP"},
    {label: "safetyNetting", display: "SAFETY NETTING"}
];

export default class AdditionalInstructionsView extends React.Component<AdditionalInstructionsViewProps> {

    render () {
        const data = !_isEmpty(this.props.patientReferrals) ? this.props.patientReferrals : [];
        return (
            <div className={"additional-instructions-view-container"}>
                {
                    !_isEmpty(data) &&
                    <div>
                        <CustomHeader headerInfos={AdditionalInstructionsHeaderInfos} rootCls={"patient-referral"}/>
                        {
                            data.map((item: IDoctorCheckInInfo, index: number) => {
                                let specialist = !_isEmpty(item) && !_isEmpty(item.doctorType) ? AppUtils.getSpecialityNameFromCode(item.doctorType.code, this.props.staticSpecialities) : null;
                                let isChecked = !_isEmpty(item) && !_isEmpty(item.consultationType) ? item.consultationType === AppConstants.ConsultationModes.INCENTRE.id : false;
                                let referralReason = !_isEmpty(item) && !_isEmpty(item.comment) ? item.comment : "";
                                let when = !_isEmpty(item) && !_isEmpty(item.activityDate) && !_isEmpty(item.activityDate.unit) ? `${item.activityDate.count} ${AppConstants.FrequencyUnit[item.activityDate.unit]}` : "";
                                if (!_isEmpty(when)) when = item.activityDate.count > 1 ? when + "s" : when;
                                return (
                                    <div className={`referral-item-view`} key={`referral-item-view-item-${index}`}>
                                        <div className={`smart-column referral-view-name`}>
                                            <span>{specialist}</span>
                                        </div>
                                        <div className="smart-column referral-editor-type">
                                            <span>{isChecked ? `In-person` : `-`}</span>
                                        </div>
                                        <div className="smart-column referral-editor-reason">
                                            <span>{referralReason}</span>
                                        </div>
                                        <div className="smart-column referral-editor-days">
                                            <span>{`${when}`}</span>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                }
                {
                    _isEmpty(data) &&
                    <div className={"no-referrals-label"}>No referrals to show</div>
                }
            </div>
        )
    }
}